import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './actions';
import IncludedExtras from '../components/accordions/IncludedExtras';
import Lease from '../components/accordions/Lease';
import ColourAndExtras from '../components/accordions/ColourAndExtras';
import { VehicleDetails } from '../../../components/vehicle';
import DeliveryDetails from './components/DeliveryDetails';

import * as routes from '../../../routes/const';

import { NitroLoading, NitroHeading, NitroNavBar, NitroDivider, NitroPanel } from 'nitro-components';
import { ColumnContainer, ColumnLarge, ColumnSmall } from '../../../components/layouts/Columns';
import Header from '../../../components/layouts/Header';

class QuoteDelivery extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      formValid: true
    };

    this.setEstimatedCost = this.setEstimatedCost.bind(this);
    this.selectColour = this.selectColour.bind(this);
    this.aToggle = this.aToggle.bind(this);
  }

  componentWillMount() {
    const { updateStep } = this.props.actions;
    const { quoteId } = this.props;
    if (!quoteId) this.context.router.push(routes.CQ_CREATE_QUESTIONS);
    updateStep(3);
  }

  componentWillUpdate(nextProps) {
    if (nextProps.quoteUpdateSuccess) this.context.router.push(routes.CQ_CREATE_SUMMARY);
  }

  setEstimatedCost(event, isInputChecked, price, code, description) {
    const { selectExtra, deSelectExtra } = this.props.actions;
    let estimatedCost = 0;

    if (isInputChecked) {
      estimatedCost = this.state.estimatedCost + price * 0.5;
      selectExtra(code, description);
    } else {
      estimatedCost = this.state.estimatedCost - price * 0.5;
      deSelectExtra(code);
    }
    this.setState({
      estimatedCost: estimatedCost
    });
  }

  selectColour(value) {
    const { selectColour } = this.props.actions;
    selectColour(value);
  }

  aToggle() {
    this.classList.toggle('active');
    this.nextElementSibling.classList.toggle('show');
  }

  formValidation = () => {
    const validCheck = true;
    this.setState({
      formValid: validCheck
    });
  };

  nextHandler = () => {
    this.context.router.push(routes.CQ_CREATE_QUESTIONS);
  };

  render() {
    const { fetchingOptions } = this.props.fetchingOptions;
    const { selectedVehicle } = this.props;

    if (fetchingOptions) return <NitroLoading screen />;

    return (
      <section>

        <Header margin="32px 0" lineHeight={32}>
          <NitroNavBar
            actionOnHeading
            lineHeight={26}
            label="Back to lease details"
            action={() => this.context.router.push(routes.CQ_CREATE_LEASE)}
            float
            noPadding
          />
          <NitroHeading label="Delivery" align="center" size="1" />
        </Header>

        <ColumnContainer>
          <ColumnSmall>
            <NitroPanel>

              <VehicleDetails disablePanelClick {...selectedVehicle} />

              <NitroDivider />

              <IncludedExtras options={this.props.options} />
              <NitroDivider />
              <ColourAndExtras selectedColour={this.props.selectedColour} selectedExtras={this.props.selectedExtras} />
              <NitroDivider />
              <Lease selectedLeaseOptions={this.props.selectedLeaseOptions} active />

            </NitroPanel>

          </ColumnSmall>

          <ColumnLarge>

            <DeliveryDetails deliveryDetails={this.props.deliveryDetails} updatingQuote={this.props.updatingQuote} />

          </ColumnLarge>
        </ColumnContainer>

      </section>
    );
  }
}

QuoteDelivery.propTypes = {
  questions: PropTypes.array.isRequired,
  vehicles: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,
  fetchingQuestions: PropTypes.bool.isRequired,
  fetchingVehicles: PropTypes.bool.isRequired,
  fetchingOptions: PropTypes.bool.isRequired,
  updatingQuote: PropTypes.bool,
  deliveryDetails: PropTypes.object,
  selectedVehicle: PropTypes.object,
  selectedLeaseOptions: PropTypes.array,
  selectedExtras: PropTypes.array,
  selectedColour: PropTypes.object,
  quoteId: PropTypes.string
};

//Pull in the React Router context so router is available on this.context.router.
QuoteDelivery.contextTypes = {
  router: PropTypes.object
};

const mapStateToProps = state => {
  // extract the relevent parts of the state you need for this view
  const { create } = state.corporateQuote;

  return {
    quoteId: create.quoteId,
    questions: create.questions,
    fetchingQuestions: create.fetchingQuestions,
    vehicles: create.vehicles,
    fetchingVehicles: create.fetchingVehicles,
    options: create.options,
    fetchingOptions: create.fetchingOptions,
    exteriorColour: create.options.ExteriorColour,
    selectedVehicle: create.selectedVehicle,
    selectedColour: create.selectedColour,
    selectedExtras: create.selectedExtras,
    deliveryDetails: create.deliveryDetails,
    selectedLeaseOptions: create.selectedLeaseOptions,
    quoteUpdateSuccess: create.quoteUpdateSuccess,
    updatingQuote: create.updatingQuote
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(QuoteDelivery);



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/QuoteDelivery.js